import { createFileRoute } from "@tanstack/react-router";
import { PageHeader, EmptyState } from "@/components/admin/AdminPrimitives";
import { CreditCard } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/assinaturas")({
  head: () => ({ meta: [{ title: "Assinaturas — Admin" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: () => (
    <div>
      <PageHeader title="Assinaturas" description="Gestão de acessos recorrentes." />
      <EmptyState
        icon={CreditCard}
        title="Modelo atual não usa assinatura"
        description="O Projeto 101 opera hoje com acesso vitalício (pagamento único). Quando a plataforma passar a oferecer planos recorrentes, esta área listará contratos ativos, cancelamentos e renovações."
      />
    </div>
  ),
});
